import {Box, Stack, SxProps} from '@mui/material'

import {SummaryScore} from './SummaryScore'
import {type SummaryScoreProps} from './types'

type SummaryScoresProps = {
  items: SummaryScoreProps[]
  sx?: SxProps
}

export const SummaryScores = ({items, sx}: SummaryScoresProps) => {
  return (
    <Stack direction="row" spacing={3} useFlexGap flexWrap="wrap" sx={{...sx}}>
      {items.map((item, index) => (
        <StackItem key={index}>
          <SummaryScore
            label={item.label}
            value={item.value}
            subscriptValue={item.subscriptValue}
            valueVariant={item.valueVariant}
            showTooltip={item.showTooltip}
            tooltip={item.tooltip}
            dataTestId={item.dataTestId}
          />
        </StackItem>
      ))}
    </Stack>
  )
}

const StackItem: React.FC<{children: React.ReactNode}> = ({children}) => (
  <Box
    sx={{
      display: 'flex',
      flex: '1 0 0'
    }}
  >
    {children}
  </Box>
)
